import imoreLogo from "@/assets/home/CaseMarquee/1MORE-logo.png";
import imoreThumb from "@/assets/home/CaseMarquee/1MORE-thumb.png";
import bluettiLogo from "@/assets/home/CaseMarquee/BLUETTI-logo.png";
import bluettiThumb from "@/assets/home/CaseMarquee/BLUETTI-thumb.png";
import proyaLogo from "@/assets/home/CaseMarquee/PROYA-logo.png";
import proyaThumb from "@/assets/home/CaseMarquee/PROYA-thumb.png";
import trajectryLogo from "@/assets/home/CaseMarquee/TRAJECTRY-logo.png";
import trajectryThumb from "@/assets/home/CaseMarquee/TRAJECTRY-thumb.png";
import timekettleLogo from "@/assets/home/CaseMarquee/Timekettle-logo.png";
import timekettleThumb from "@/assets/home/CaseMarquee/Timekettle-thumb.jpg";
import xingyunLogo from "@/assets/home/CaseMarquee/XINGYUN-logo.png";
import xingyunThumb from "@/assets/home/CaseMarquee/XINGYUN-thumb.png";
import dongchediLogo from "@/assets/home/CaseMarquee/dongchedi-logo.png";
import dongchediThumb from "@/assets/home/CaseMarquee/dongchedi-thumb.png";
import matrixLogo from "@/assets/home/CaseMarquee/matrix-logo.png";
import matrixThumb from "@/assets/home/CaseMarquee/matrix-thumb.jpg";
import zdeerThumb from "@/assets/home/CaseMarquee/zdeer-htumb.png";
import zdeerLogo from "@/assets/home/CaseMarquee/zdeer-logo.png";
import logo01 from "@/assets/home/logo/01_PROYA.png";
import logo02 from "@/assets/home/logo/02_P&G_.png";
import logo03 from "@/assets/home/logo/03_PLUG_AND_PLAY_CHINA.png";
import logo04 from "@/assets/home/logo/04_Transsion.png";
import logo05 from "@/assets/home/logo/05_KERING_FOUNDATION.png";
import logo06 from "@/assets/home/logo/06_dingchedi.png";
import logo07 from "@/assets/home/logo/07_CARSLAN.png";
import logo08 from "@/assets/home/logo/08_lebo.png";
import logo09 from "@/assets/home/logo/09_Timekettle.png";
import logo10 from "@/assets/home/logo/10_XINGYUN_GROUP.png";
import logo11 from "@/assets/home/logo/11_BLUETTI.png";
import logo12 from "@/assets/home/logo/12_1MORE.png";
import logo13 from "@/assets/home/logo/13_LEE_KUM_KEE.png";
import logo14 from "@/assets/home/logo/14_FUNNY_FUZZY.png";
import logo15 from "@/assets/home/logo/15_FILIPPO_LORETI.png";
import logo16 from "@/assets/home/logo/16_zdeer.png";
import logo17 from "@/assets/home/logo/17_TRAJECTRY.png";
import logo18 from "@/assets/home/logo/18_IRS_Group.png";
import logo19 from "@/assets/home/logo/19_reenda.png";
import logo20 from "@/assets/home/logo/20_C77GLOBAL.png";
import logo21 from "@/assets/home/logo/21_WaytoAGI.png";
import logo22 from "@/assets/home/logo/22_HONG.png";
import logo23 from "@/assets/home/logo/23_ESTEE_LAUDER.png";
import logo24 from "@/assets/home/logo/24_matrix.png";
import logo25 from "@/assets/home/logo/25_CHANGAN.png";
import { CaseMarquee } from "@/components/CaseMarquee";
import { EngineGrid } from "@/components/EngineGrid";
import { LeadFormDialog } from "@/components/LeadFormDialog";
import { Nebula } from "@/components/Nebula";
import { MEGA_MENU_EXTERNAL_URLS } from "@/i18n/menu-external-urls";
import { useT } from "@/lib/i18n";
import { getToken } from "@/lib/utils/auth-storage";
import { useSubAppNavigation } from "@/hooks/use-sub-app-nav";
import { ArrowRight, Quote } from "lucide-react";
import { useState } from "react";

const clientLogos = [
  logo01, logo02, logo03, logo04, logo05, logo06, logo07, logo08, logo09, logo10,
  logo11, logo12, logo13, logo14, logo15, logo16, logo17, logo18, logo19, logo20,
  logo21, logo22, logo23, logo24, logo25,
];

interface HomePageProps {
  activeTab?: string;
  setActiveTab?: (tab: string) => void;
  onScrollToFooter?: () => void;
  onHideFooter?: () => void;
  /** 请求弹出登录弹窗，传入 'toolbox' 表示登录后跳转 toolbox */
  onRequestLogin?: (redirect?: "toolbox") => void;
}

function SectionHeader({ kicker, title, sub }: { kicker?: string; title: string; sub?: string }) {
  return (
    <div className="text-center max-w-3xl mx-auto mb-16">
      {kicker && <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">{kicker}</p>}
      <h2 className="text-4xl md:text-5xl font-semibold tracking-tight">{title}</h2>
      {sub && <p className="mt-6 text-base text-muted-foreground/90 leading-relaxed">{sub}</p>}
    </div>
  );
}

const HomePage: React.FC<HomePageProps> = ({ onRequestLogin }) => {
  const t = useT();
  const [formOpen, setFormOpen] = useState(false);
  const { navigating: isNavigatingToToolbox, navigate } = useSubAppNavigation();

  const handleExploreProducts = async () => {
    // GA4 埋点：立即体验按钮点击
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'cta_click', {
        event_category: 'homepage',
        event_label: 'try_now',
        button_text: 'Try Now / 立即体验'
      });
    }

    const token = getToken();
    if (!token) {
      // 未登录：弹出登录框，登录成功后自动跳转 toolbox
      onRequestLogin?.("toolbox");
      return;
    }
    // 已登录：跳转 toolbox（shared 模式直接跳，oauth2 模式先获取 code 再跳）
    await navigate('toolbox');
  };

  const engines = [
    {
      name: "OranHub",
      tag: t("Insight & Strategy", "洞察决策"),
      line: t("Read the market. Build a plan that works.", "读懂市场，拿到一份真正能落地的计划。"),
      href: MEGA_MENU_EXTERNAL_URLS["menu.prod.insights"],
    },
    {
      name: "OranSim",
      tag: t("Simulation & Foresight", "预测引擎"),
      line: t(
        "Test campaigns in a parallel universe — before you spend.",
        "在花钱之前，先在平行世界里把整场营销跑一遍。",
      ),
      href: MEGA_MENU_EXTERNAL_URLS["menu.prod.strategy"],
    },
    {
      name: "OranGen",
      tag: t("Content Factory", "内容工厂"),
      line: t(
        "Turn one winning idea into 30+ ready-to-publish creatives.",
        "一个最优创意，裂变成 30+ 条可直接发布的内容。",
      ),
      href: MEGA_MENU_EXTERNAL_URLS["menu.prod.contentFactory"],
    },
    {
      name: "OranMed",
      tag: t("Distributed Media", "分布式媒介"),
      line: t(
        "Distribute at scale — through owned accounts and real creators.",
        "通过自有账号和真实创作者，实现规模化分发。",
      ),
      // 待用户提供 OranMed 外链 — 暂留占位
    },
  ];

  const testimonials = [
    {
      tag: t("Content Production", "内容生产"),
      metric: t("Systematic & Reusable", "系统且可复用"),
      quote: t(
        "OranAI helped our performance video team integrate AI into daily content production, making script ideation, viral-content analysis, video replication, and asset accumulation more systematic, stable, and reusable.",
        "橙果视界帮助我们的信息流视频团队把 AI 融入日常内容生产，让脚本创意、爆款拆解、视频复刻和素材沉淀变得更加系统、稳定、可复用。",
      ),
      name: t("PROYA", "珀莱雅"),
      role: t("Brand", "品牌"),
      meta: t("Beauty · China", "美妆 · 中国"),
    },
    {
      tag: t("Product Launch", "新品上线"),
      metric: t("Faster Visual Output", "更快产出视觉素材"),
      quote: t(
        "Product launches used to stall on visuals. Now with OranAI, we can quickly generate consistent assets for any platform, and our update cycles feel much smoother.",
        "过去新品上线最耗时间的是成套产品图和场景素材。和橙果视界合作后，我们可以围绕不同平台、不同人群快速生成统一风格的产品视觉，官网、电商详情页和营销素材的更新节奏明显更顺了。",
      ),
      name: t("Zdeer", "左点"),
      role: t("Brand", "品牌"),
      meta: t("Healthcare · China", "医疗 · 中国"),
    },
    {
      tag: t("Digital Assets", "数字资产"),
      metric: t("Systematic Management", "系统化管理"),
      quote: t(
        "OranAI didn’t just help us produce content—it gave us a real digital asset foundation. We’ve moved from scattered storage to proper content management.",
        "AIGC 时代，品牌资产的价值不只在于产出，更在于能否被管理、复用和安全流转。橙果视界帮我们补上了数字资产底座，让内容运营从'分散存放'走向'系统管理'。",
      ),
      name: t("Matrix Design", "矩阵纵横"),
      role: t("Design Firm", "设计公司"),
      meta: t("Interior Design · China", "室内设计 · 中国"),
    },
    {
      tag: t("Social Media", "社媒内容"),
      metric: t("Natural & Engaging", "自然且易互动"),
      quote: t(
        "Headphone content can easily turn into dry spec sheets. OranAI helps us create natural, lifestyle-focused visuals for social media—without the tech overload.",
        "耳机内容最怕拍得太像参数展示，用户很难感受到真实佩戴和使用场景。和橙果视界合作后，我们能更快生成适合不同社媒平台的视觉素材，把音质、佩戴感和生活方式氛围表达得更自然，也更接近用户愿意互动和种草的内容形态。",
      ),
      name: t("1MORE", "万魔"),
      role: t("Brand", "品牌"),
      meta: t("Audio · Global", "音频 · 全球"),
    },
    {
      tag: t("Global Communication", "全球传播"),
      metric: t("Unified Expression", "统一表达"),
      quote: t(
        "For global markets, it’s not just showing the product—it’s making instant communication instantly understandable. OranAI gave us unified, professional short-form visuals that work across channels.",
        "对 Timekettle 来说，海外传播的关键不只是展示产品，而是让不同市场的用户快速理解即时沟通的价值。橙果视界帮助我们建立了更统一的视觉与短视频内容表达，让产品在社媒投放、内容更新和多渠道传播中保持一致、专业且易于理解。",
      ),
      name: t("Timekettle", "时空壶"),
      role: t("Brand", "品牌"),
      meta: t("Translation · Global", "翻译 · 全球"),
    },
  ];

  return (
    <div className="landing-v2 min-h-screen text-foreground">
      {/* HERO */}
      <section className="relative min-h-screen overflow-hidden pt-28">
        <Nebula groups={7} perGroup={70}>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background/80 pointer-events-none" />
          <div className="relative h-full min-h-screen flex items-center justify-center">
            <div className="relative z-10 text-center px-6 max-w-[min(1400px,90vw)] mx-auto">
              <a href="https://whitebook.photog.art/background" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 glass px-4 py-1.5 text-xs text-muted-foreground mb-8 hover:text-foreground transition-colors">
                <span className="h-1.5 w-1.5 rounded-full bg-[hsl(var(--brand))] animate-pulse-glow" />
                {t("OranAI Whitepaper Is Now Live!", "OranAI 白皮书已上线！")}
              </a>
              <h1 className="text-5xl md:text-7xl font-semibold tracking-tight leading-[1.05] text-foreground">
                {t(<>Your AI MCN</>, <>你的 AI 全域达人网络</>)}
              </h1>
              <p className="mt-10 text-xl md:text-2xl text-foreground font-medium">
                {t("Empower Every Brand to Be Heard", "让世界听见每一个品牌的声音")}
              </p>
              <p className="mt-6 max-w-2xl mx-auto text-base md:text-lg text-muted-foreground leading-relaxed">
                {t(
                  "Creator ecosystem defines influence, all-domain intelligence ensures certainty — from distribution to amplification, prediction to efficient reach, delivering full-funnel brand growth coverage.",
                  "达人生态定义影响力，全域智能锁定确定性。从内容分发到势能放大，从效果预测到高效触达，让品牌增长再无盲区",
                )}
              </p>
              <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
                <button
                  className="btn-primary"
                  onClick={handleExploreProducts}
                  disabled={isNavigatingToToolbox}
                >
                  {isNavigatingToToolbox
                    ? t("Redirecting…", "跳转中…")
                    : <>{t("Try Now", "立即体验")} <ArrowRight size={16} /></>}
                </button>
                <button className="btn-secondary" onClick={() => setFormOpen(true)}>
                  {t("Contact us", "联系我们")}
                </button>
              </div>
              <div className="mt-16 flex flex-wrap justify-center gap-x-10 gap-y-3 text-xs text-muted-foreground">
                <span>
                  <span className="text-foreground font-medium">200+</span> {t("Brands & Creators", "品牌与创作者")}
                </span>
                <span>
                  <span className="text-foreground font-medium">1.2M</span> {t("Pieces Distributed", "内容分发")}
                </span>
                <span>
                  <span className="text-foreground font-medium">5</span> {t("Platforms Covered", "覆盖平台")}
                </span>
              </div>
            </div>
          </div>
        </Nebula>
      </section>

      {/* CLIENT LOGO MARQUEE */}
      <section className="relative mt-0 pb-20 overflow-hidden">
        <div className="relative mx-auto max-w-[min(1760px,95vw)] px-6 h-24 overflow-hidden">
          <div className="pointer-events-none absolute inset-y-0 left-0 w-32 z-10 bg-gradient-to-r from-background to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-32 z-10 bg-gradient-to-l from-background to-transparent" />
          <div className="flex gap-8 animate-marquee-x w-max">
            {[...clientLogos, ...clientLogos, ...clientLogos].map((logo, i) => (
              <img
                key={i}
                src={logo}
                alt={`Client logo ${i + 1}`}
                className="h-12 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
              />
            ))}
          </div>
        </div>
      </section>

      {/* FOUR ENGINES */}
      <section className="relative py-32 px-6">
        <div className="mx-auto max-w-[min(1760px,95vw)]">
          <SectionHeader
            kicker={t("Product Matrix", "产品矩阵")}
            title={t("Four Engines, One Closed Loop.", "四大引擎，一个闭环。")}
            sub={t(
              "Insight fuels simulation. Simulation directs creation. Creation drives distribution. Every signal returns as the starting point of your next growth.",
              "洞察驱动预演，预演指导生产，生产带动分发，每一个信号回流成下一次增长的起点。",
            )}
          />
          <EngineGrid engines={engines} t={t} />
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="relative py-32 px-6 overflow-hidden">
        <div className="mx-auto max-w-[min(1760px,95vw)]">
          <SectionHeader
            kicker={t("Voices", "声音")}
            title={t("What Our Partners Say.", "客户与创作者的声音。")}
            sub={t(
              "Real teams, real numbers — from first idea to first revenue.",
              "真实团队，真实数据 —— 从第一个想法到第一笔收入。",
            )}
          />
          <div className="relative w-full overflow-hidden rounded-2xl">
            <div className="pointer-events-none absolute inset-y-0 left-0 w-[18%] z-10 bg-gradient-to-r from-background to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-[18%] z-10 bg-gradient-to-l from-background to-transparent" />
            <div className="flex gap-8 animate-marquee-x w-max py-4">
              {[...testimonials, ...testimonials, ...testimonials].map((tm, i) => {
                const initial = (tm.name || tm.role).trim().charAt(0).toUpperCase();
                return (
                  <article
                    key={i}
                    className="testi-card glass nebula-border relative p-10 flex flex-col shrink-0"
                    style={{ width: "min(42vw, 600px)", minHeight: "360px" }}
                  >
                    <Quote
                      aria-hidden
                      size={120}
                      className="absolute -top-4 -right-2 opacity-[0.05] pointer-events-none"
                      style={{ color: "hsl(var(--brand))" }}
                    />
                    <div className="flex items-center justify-between gap-4 mb-6 relative">
                      <span className="text-xs px-3 py-1 glass rounded-full tracking-wider">{tm.tag}</span>
                      <span className="text-xs uppercase tracking-[0.2em] brand-text font-medium">{tm.metric}</span>
                    </div>
                    <p className="text-lg md:text-xl font-medium leading-relaxed text-foreground/95 flex-1">
                      &ldquo;{tm.quote}&rdquo;
                    </p>
                    <div className="divider-nebula my-6" />
                    <div className="flex items-center gap-4">
                      <div
                        className="h-11 w-11 rounded-full grid place-items-center text-sm font-semibold"
                        style={{
                          background:
                            "linear-gradient(135deg, color-mix(in oklab, hsl(var(--brand)) 35%, transparent), oklch(1 0 0 / 0.06))",
                          border: "1px solid color-mix(in oklab, hsl(var(--brand)) 45%, transparent)",
                          color: "hsl(var(--foreground))",
                        }}
                      >
                        {initial}
                      </div>
                      <div className="flex-1">
                        <p className="text-sm font-medium">
                          {tm.name}
                          <span className="text-muted-foreground"> · {tm.role}</span>
                        </p>
                        <p className="text-xs text-muted-foreground mt-0.5">{tm.meta}</p>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDIES */}
      <section className="relative py-32 px-6">
        <div className="mx-auto max-w-[min(1760px,95vw)]">
          <SectionHeader
            title={t("From Insight to Impact — In Days, Not Months.", "洞察到触达，只需几天。")}
            sub={t(
              "See how real teams use OranAI to research, predict, create, and reach.",
              "看看真实团队如何用 OranAI 完成调研、预演、创造和触达。",
            )}
          />
          <CaseMarquee
            readLabel={t("Read Full Case", "阅读完整案例")}
            cases={[
              {
                brand: t("PROYA", "珀莱雅"),
                logo: proyaLogo,
                thumb: proyaThumb,
                tags: [t("Beauty", "美妆"), t("Content Production", "内容生产")],
                title: t("PROYA", "珀莱雅"),
                desc: t(
                  "What we did\nOranAI ran a hands-on training program for the client’s Douyin video team — directors, editors, remix editors, everyone. We worked on real production tasks: scripting, breaking down viral videos, analyzing first-3-second hooks, cloning clips, generating AI openers, organizing assets, and automating repetitive steps.\n\nThe outcome\nThe team moved from scattered, manual workflows to a repeatable AI-powered production loop — analyze, generate, clone, reuse. No more reinventing the wheel for every new video.",
                  "我们做了什么\n橙果视界为客户抖音视频团队提供实操陪跑，覆盖编导、剪辑、混剪等核心岗位。我们围绕真实内容生产场景展开：脚本创作、爆款拆解、前三秒 Hook 分析、视频复刻、AI 开头生成、素材整理和自动化流程。\n\n成果\n团队从分散、手动的生产方式转向可复用的 AI 驱动闭环——拆解、生成、复刻、复用。不再为每条新视频重复造轮子。",
                ),
                bullets: [
                  t("AI Creative Production Efficiency 60%+", "AI 创意生产效率提升 60%+"),
                  t("Information-Flow Content Testing Efficiency 40%+", "信息流内容测试链路提效 40%+"),
                  t("Core Role AI Capability Coverage 50+ Team Members", "核心岗位 AI 能力覆盖 50+ 人"),
                ],
              },
              {
                brand: t("dongchedi", "懂车帝"),
                logo: dongchediLogo,
                thumb: dongchediThumb,
                tags: [t("Automotive", "汽车"), t("Content Generation", "内容生成")],
                title: t("懂车帝", "懂车帝"),
                desc: t(
                  "What we did\nFor the client's new-car testing workflow, OranAI built a batch content engine that blends images, price-inquiry templates, video storyboards, and AI-generated product descriptions into a simple, repeatable system. Upload car assets, pick a template, swap text, run batch rendering — and AI handles the rest.\n\nThe outcome\nThe old one-by-one content grind is gone. Now it's a smart production line that scales effortlessly — pump out high-frequency test-drive content and pricing materials without burning time or budget.",
                  "我们做了什么\n针对新车测试工作流，橙果视界构建了一套批量内容引擎，将单车图文、询底价模板、视频分镜与 AI 述品整合为简单、可复用的系统。上传车型素材、选择模板、替换文字、运行批量渲染 —— AI 自动处理其余环节。\n\n成果\n逐条制作内容的旧模式已成过去。现在是一条可轻松扩展的智能生产线 —— 高频产出试驾内容和询底价素材，不再大量消耗时间和预算。",
                ),
                bullets: [
                  t("Daily Content Output per Person 8x", "单人日均内容产出提升 8x"),
                  t("Overall Production Cost Reduction 70%+", "综合内容制作成本降低 70%+"),
                ],
              },
              {
                brand: t("zdeer", "左点"),
                logo: zdeerLogo,
                thumb: zdeerThumb,
                tags: [t("Healthcare", "医疗"), t("Product Visuals", "产品视觉")],
                title: t("zdeer", "左点"),
                desc: t(
                  "What we did\nFor the client’s smart health and personal care products, OranAI generated AI‑powered product visuals tailored to official sites, e‑commerce detail pages, and marketing campaigns. We mapped product benefits to real usage scenarios, consumer mindsets, and platform standards — turning specs into story‑driven, trustworthy, conversion‑ready images.\n\nThe outcome\nNow their product assets go live faster, visual refreshes happen without delay, and the brand looks polished and consistent across every key touchpoint — from the homepage to checkout.",
                  "橙果视界围绕客户智能健康与个人护理产品的线上营销需求，提供 AI 产品视觉生成服务，系统化产出可用于官网展示、购物平台详情页及营销传播的产品图片。项目结合产品功能、使用场景、消费人群与平台展示规范，将产品卖点转化为更具场景感、信任感与转化引导力的视觉内容，帮助客户提升商品素材上线效率与视觉内容更新速度，并在官网、电商平台及核心营销触点中形成更统一、更高质感的产品表达。",
                ),
                bullets: [
                  t("Product Asset Launch Efficiency 3x", "商品素材上线效率提升 3x"),
                  t("Visual Content Iteration Speed 60%+", "视觉内容更新迭代提速 60%+"),
                  t("Core Marketing Scenario Coverage Rate 50%+", "核心营销场景覆盖率提升 50%+"),
                ],
              },
              {
                brand: t("matrix", "matrix"),
                logo: matrixLogo,
                thumb: matrixThumb,
                tags: [t("Interior Design", "室内设计"), t("Digital Assets", "数字资产")],
                title: t("matrix", "matrix"),
                desc: t(
                  "What we did\nOranAI built an enterprise-grade digital asset platform for the client — one place to collect, store, manage, search, collaborate, and distribute brand content. We added smart tagging, AI-powered search, multi-space organization, real-time team collaboration, granular permissions, and secure external sharing.\n\nThe outcome\nScattered assets across teams and channels finally have a home. No more hunting for files or remaking what already exists. The team works faster, duplicate costs drop, and data leaks are no longer a constant worry — giving the brand a solid digital foundation for the long run.",
                  "我们做了什么\n橙果视界为客户打造了一套企业级数字资产管理平台——统一的内容采集、存储、管理、检索、协同和分发中心。我们实现了智能标签、AI 检索、多空间管理、实时多人协作、精细化权限和安全外部分享。\n\n成果\n分散在各团队和渠道的资产终于有了归属。不再为找文件浪费时间和重复制作已有内容。团队协作更高效，重复成本下降，数据泄露不再是持续的担忧——为品牌长期运营奠定了坚实的数字化基础。",
                ),
                bullets: [
                  t("Annual Cost Savings: RMB 3M+ (cumulative)", "年度成本节省 累计 300万+"),
                  t("Asset Retrieval Efficiency: 85%", "资产检索效率提升 85%"),
                  t("Data Security Risk Reduction: 50%", "数据安全风险降低 50%"),
                ],
              },
            ]}
          />
        </div>
      </section>

      

      {/* FINAL CTA */}
      <section className="relative py-32 px-6 overflow-hidden">
        <div className="absolute inset-0 opacity-50">
          <Nebula groups={4} perGroup={18} />
        </div>
        <div className="relative z-10 mx-auto max-w-4xl text-center">
          <h2 className="text-5xl md:text-7xl font-semibold tracking-tight leading-[1.05]">
            {t(
              <>
                Stop Betting.
                <br />
                <span className="brand-text">Start Knowing.</span>
              </>,
              <>
                告别未知，
                <br />
                <span className="brand-text">开始预见。</span>
              </>,
            )}
          </h2>
          <p className="mt-10 max-w-xl mx-auto text-muted-foreground">
            {t(
              "Enter your brand name. Get your first diagnosis in 5 minutes.",
              "输入品牌名，5分钟就能拿到你的第一份诊断报告。",
            )}
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <button className="btn-secondary" onClick={() => setFormOpen(true)}>
              {t("Contact us", "联系我们")}
            </button>
            <button
              className="btn-primary"
              onClick={handleExploreProducts}
              disabled={isNavigatingToToolbox}
            >
              {isNavigatingToToolbox
                ? t("Redirecting\u2026", "跳转中\u2026")
                : <>{t("Explore Products", "探索产品")} <ArrowRight size={16} /></>
              }
            </button>
          </div>
          <p className="mt-10 text-xs text-muted-foreground">
            {t(
              "No credit card required · Setup in minutes · Built to fuel every step of your growth.",
              "无需信用卡 · 几分钟即用 · 为你的每一步增长注入动力",
            )}
          </p>
        </div>
      </section>

      <LeadFormDialog open={formOpen} onOpenChange={setFormOpen} />
    </div>
  );
};

export default HomePage;
